import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {GameLoadingIndicatorComponent} from "../game-window/loading-indicators/game-loading-indicator.component";
import React from "react";

@observer
export class CurrentGameContainerComponent extends OrbitComponent {
    render() {
        if(this.services.gameRunner.gameLoadingIndicator) {
            return (<GameLoadingIndicatorComponent/>);
        }

        const currentRunningGame = this.services.gameRunner.currentRunningGame;
        if(!currentRunningGame) {
            return null;
        }

        return currentRunningGame.renderGame();
    }
}